import { TableLinkColumnDTO } from '../table/table-link-column-dto'

export class ReddiHistoryTableDTO {
  presentationDate: string
  age: number
  presenterType: string
  presenterName: string
  notes: string
  viewReport?: TableLinkColumnDTO
  impactingFactors: string
}
